<template>
  <div>
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="system">
      <img v-if="data.img" :src="require('../../assets/message/' + data.img)">
      <div class="title">
        {{ data.title }}
      </div>
      <div class="time">
        {{ data.time }}
      </div>
      <div class="content">
        {{ data.content }}
      </div>
    </div>
  </div>
</template>
<script>
import listJson from './message.json'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    // 回获取路由参数
    const { id } = this.$route.query;
    let data = listJson.find(item => item.id === id);
    this.data = data;
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 4 } })
    }
  },
}
</script>
<style lang="less" scoped>
.system {
  width: 90%;
  margin: 0 auto;

  img {
    width: 100%;
  }

  .title {
    line-height: 20px;
    color: rgb(16, 16, 16);
    font-weight: bold;
  }

  .time {
    color: rgb(16, 16, 16);
    line-height: 20px;
    margin: 10px 0;
  }

  .content {
    color: rgb(16, 16, 16);
    line-height: 20px;
  }
}
</style>